<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <ion-card class="title">
        <ion-card-header color="secondary">
          <ion-card-title class="ion-text-center" size="large">交換・撤去</ion-card-title>
        </ion-card-header>
      <ion-card-content>
        <div id="video-input">
            <video id="video" autoplay playsinline width="300" height="300"></video>
            <canvas id="canvas" width="300" height="300"></canvas>
        </div>
      </ion-card-content>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonPage, IonCardTitle, IonCard, IonCardContent, alertController } from '@ionic/vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Change',
  components: {
    IonContent,
    IonPage,
    IonCardTitle,
    IonCard,
    IonCardContent,
  },
  data(){
      return {
        url:'',
        player: '',
        canvas: '',
        conta:'',
        memberId:'',
        genbaName: '',
        address: '',
        startDate: '',
        contCd: ''
      };
  },
  ionViewDidEnter() {
    this.initVideo();
  },
  mounted(){
    this.initVideo();
  },
  methods: {
    initVideo: function () {
      this.player = document.getElementById('video');
      this.canvas = document.getElementById('canvas');
      
      if (navigator.mediaDevices) {
          navigator.mediaDevices.getUserMedia({
              audio: false,
              video: {
                width: 300,
                height: 300,
                facingMode: "environment"  
              }
          })
              .then(this.handleSuccess)
              .catch(function (err) {
                  console.log(JSON.stringify(err));
                  console.log('handle err');
              });
      } else {
          alert('ビデオカメラを使用できません');
      }
    },
    startScan: function (callback) {
      let self = this;
      const width = this.canvas.width;
      const height = this.canvas.height;
      var canvasContext = this.canvas.getContext('2d');

      var intervalHandler = setInterval(function () {
          if(canvasContext!=null){
            canvasContext.drawImage(self.player, 0, 0, width, height);
            var imageData = canvasContext.getImageData(0, 0, width, height);
            var scanResult = window.jsQR(imageData.data, imageData.width, imageData.height);
          }
          if (scanResult) {
              clearInterval(intervalHandler);
              callback(scanResult);
              self.drawLine(canvasContext, scanResult.location);

              // video と canvas を入れ替え
              self.canvas.style.display = 'block';
              self.player.style.display = 'none';
              self.player.pause();

              self.player.srcObject.getTracks().forEach(function(track) {
                track.stop();
              });
          }
      }, 200);
    },
    handleSuccess: function (stream) {
        var self = this
        self.player.srcObject = stream;

        self.startScan(async function (scanResult) {
          self.url = scanResult.data;

          await self.axios.get('genba-change', { params: {'enc_string': self.url} }).then(res => {
            if(res.data["result"] == "success"){
              self.memberId = res.data["member_id"];
              self.genbaName = res.data["genba_name"];
              self.address = res.data["address"];
              self.startDate = res.data["start_date"];
              self.contCd = res.data["cont_cd"];

              // カメラの停止
              if(self.player.srcObject!==null){
                self.player.pause();
                self.player.srcObject.getTracks().forEach(function(track) {
                  track.stop();
                });
              }
              self.$router.push({ name: 'Kakutei', params: { 
                memberId: self.memberId,
                genbaName: self.genbaName,
                address: self.address,
                startDate: self.startDate,
                contCd: self.contCd
              }});
            }else{
              self.presentAlert();              
            }
          });
        });
    },
    drawLine: function (ctx, pos, options={color:"blue", size:5}) {
      // 線のスタイル設定
      ctx.strokeStyle = options.color;
      ctx.lineWidth   = options.size;

      // 線を描く
      ctx.beginPath();
      ctx.moveTo(pos.topLeftCorner.x, pos.topLeftCorner.y);         // 左上からスタート
      ctx.lineTo(pos.topRightCorner.x, pos.topRightCorner.y);       // 右上
      ctx.lineTo(pos.bottomRightCorner.x, pos.bottomRightCorner.y); // 右下
      ctx.lineTo(pos.bottomLeftCorner.x, pos.bottomLeftCorner.y);   // 左下
      ctx.lineTo(pos.topLeftCorner.x, pos.topLeftCorner.y);         // 左上に戻る
      ctx.stroke();
    },
    presentAlert: async function () {
      const alert = await alertController.create({
        header: 'エラー',
        message: 'コンテナが見つかりません。',
        buttons: [
          {
            text: '閉じる',
            role: 'cancel',
            handler: () => {
              this.initVideo();
            }
          }
        ]
      });

      await alert.present();
    },
    backPage: function(){
      if(this.player.srcObject!==null){
        this.player.pause();
        this.player.srcObject.getTracks().forEach(function(track) {
          track.stop();
        });
      }
      this.$router.back();
    }
  },
});
</script>

<style scoped>
#video, #canvas {
  justify-content:center;
  margin-top:20px;
  margin-left: auto;
  margin-right: auto;
}
#canvas {
  display:none;
}
#qr {
  margin-left:10px;
}
.contena {
  margin-left:20px;
}
#next {
  margin:20px;
}
#title {
  width:100%;
  margin-left:auto;
  margin-right:auto;
}
#contena-text {
  font-size:20px;
  text-decoration: underline;
  color: rgb(25, 148, 170);
}
</style>